/**
 * 根据参照dom元素的 getBoundingClientRect() 获取弹窗位置
 * @see getBoundingClientRect
 * @param refElemRect 参照物domRect
 * @param elemRect 展示元素domRect
 * @param popLocation 展示元素显示位置
 *        auto: 自动适应
 *        top: 正上方
 *        top-right: 右上方
 *        right: 正右方
 *        right-bottom: 右下方
 *        bottom: 正下方
 *        bottom-left: 左下方
 *        left: 正左方
 *        left-top: 左上方
 * @param offset 展示元素偏离参照元素的距离（负数表示贴近元素）
 * @return 计算元素定位style
 */
export const lookElementXY = function(refElemRect, elemRect, popLocation = "auto", offset = -15) {
  let style = {};
  // //参照物x中心
  let xCenter = refElemRect.left + (refElemRect.width / 2);
  // //参照物y中心
  let yCenter = refElemRect.top + (refElemRect.height / 2);
  switch (popLocation) {
    case "top":
      style.top = refElemRect.top - elemRect.height - offset;
      style.left = xCenter - (elemRect.width / 2);
      break;
    case "top-right":
      style.top = refElemRect.top - elemRect.height - offset;
      style.left = refElemRect.right + offset;
      break;
    case "right":
      style.top = yCenter - (elemRect.height / 2);
      style.left = refElemRect.right + offset;
      break;
    case "right-bottom":
      style.top = refElemRect.bottom + offset;
      style.left = refElemRect.right + offset;
      break;
    case "bottom":
      style.top = refElemRect.bottom + offset;
      style.left = xCenter - (elemRect.width / 2);
      break;
    case "bottom-left":
      style.top = refElemRect.bottom + offset;
      style.left = refElemRect.left - elemRect.width - offset;
      break;
    case "left":
      style.top = yCenter - (elemRect.height / 2);
      style.left = refElemRect.left - elemRect.width - offset;
      break;
    case "left-top":
      style.top = refElemRect.top - elemRect.height - offset;
      style.left = refElemRect.left - elemRect.width - offset;
      break;
    default:
      let location;
      if ((window.innerWidth / 2) > xCenter) {
        // style.left = (domRect.right - xOffset) + "px";
        if ((window.innerHeight / 2) > yCenter) {
          location = "right-bottom";
          //竖直方向如果超出屏幕
          if (refElemRect.bottom + elemRect.height > window.innerHeight)
            location = "right"
        } else {
          location = "top-right";
          //竖直方向如果超出屏幕
          if (elemRect.height > refElemRect.top)
            location = "right"
        }
      } else {
        // style.right = (window.innerWidth - domRect.right - xOffset) + "px";
        if ((window.innerHeight / 2) > yCenter) {
          location = "bottom-left";
          //竖直方向如果超出屏幕
          if (refElemRect.bottom + elemRect.height > window.innerHeight)
            location = "left"
        } else {
          location = "left-top";
          //竖直方向如果超出屏幕
          if (elemRect.height > refElemRect.top)
            location = "left"
        }
      }
      return lookElementXY(refElemRect, elemRect, location, offset);
  }
  for (let k in style) {
    if (style.hasOwnProperty(k))
      style[k] += "px";
  }
  return style;
};



// WEBPACK FOOTER //
// ./src/js/utils/domLocation.js